import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import NotFoundPage from '../views/NotFoundPage.vue'
import Fed from "../views/Fed";
import TransactionView from "../views/TransactionView";
import {isTokenValid} from "../requesters/httpClient";
import {parameters} from "../parameters";

Vue.use(VueRouter);


const routes = [
  {
    name: 'home',
    path: '/',
    component: Home
  },
  {
    name: 'share',
    path: '/share/:criteria',
    component: Home
  },
  {
    name: 'shared',
    path: '/shared',
    component: Home
  },
  {
    name: 'fed',
    path: '/accessToken/:fedParams?',
    component: Fed
  },
  {
    name: 'transactionViewShortcut',
    path: '/transaction/:transactionId',
    redirect: '/transaction/:transactionId/anonymized/xml'
  },
  {
    name: 'transactionView',
    path: '/transaction/:transactionId/:anonymized/:view?/:messageDateTime?/:version?',
    component: TransactionView
  },
  {
    path: '*',
    name: 'NotFoundPage',
    component: NotFoundPage
  }
];

const router = new VueRouter({
  mode: 'history',
  routes
});

// Add guard for every route to validate authentication (or redirect to Fed)
router.beforeEach((to, from, next) => {
  if(to.name ==='fed') {
    next();
  } else if(!isTokenValid()) {
      localStorage.setItem('poslog_url_backup', window.location.href);
      const codeChallenge = makeRandomString(50)
      localStorage.setItem('codeChallenge', codeChallenge)
      location.replace(`${parameters.fedUrl}/as/authorization.oauth2?client_id=${parameters.clientId}&response_type=code&redirect_uri=${parameters.redirectUri}&scope=openid%20profile%20email&code_challenge=` + codeChallenge + `&code_challenge_method=plain`);

  } else {
    next();
  }
});

function makeRandomString(length) {
  let result           = '';
  let characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let charactersLength = characters.length;
  for (let i = 0; i < length; i++ ) {
    result += characters.charAt(Math.floor(Math.random() *
        charactersLength));
  }
  return result;
}

export default router
